export const sortBy = [
  'Start Date: Soonest to Latest',
  'Start Date: Latest to Soonest',
  'End Date: Soonest to Latest',
  'End Date: Latest to Soonest',
];

// API params (sort_by / sort_type) for each sortBy option
export const sortQueryParams = {
  'Start Date: Soonest to Latest': { sortBy: 'start_date', sortType: 'asc' },
  'Start Date: Latest to Soonest': { sortBy: 'start_date', sortType: 'desc' },
  'End Date: Soonest to Latest': { sortBy: 'end_date', sortType: 'asc' },
  'End Date: Latest to Soonest': { sortBy: 'end_date', sortType: 'desc' },
};

export const sortSearchResults = (results, sortType) => {
  const sortedResults = [...results];

  switch (sortType) {
    case 'Start Date: Soonest to Latest':
      sortedResults.sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate)
      );
      break;
    case 'Start Date: Latest to Soonest':
      sortedResults.sort(
        (a, b) => new Date(b.startDate) - new Date(a.startDate)
      );
      break;
    case 'End Date: Soonest to Latest':
      sortedResults.sort((a, b) => new Date(a.endDate) - new Date(b.endDate));
      break;
    case 'End Date: Latest to Soonest':
      sortedResults.sort((a, b) => new Date(b.endDate) - new Date(a.endDate));
      break;
    default:
      console.error('Invalid sort type');
      return results;
  }

  return sortedResults;
};
